import React from "react";
// import loader from "../assets/images/svgs/ic_loader_lazyload.svg";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

import { ColorPrimary } from "../config/constant/color/index";

export const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        transform: "translate(-50%, -50%)",
        top: "50%",
        left: "50%",
        position: "fixed",
      }}
    >
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 48,
              color: ColorPrimary,
            }}
            spin
          />
        }
      />
    </div>
  );
};
